// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"fd0b35cc","839":"ae52a6f9"}[chunkId] + ".chunk.css";
};